import { Box, CircularProgress, Paper, Stack } from '@mui/material';
import { Suspense, useState } from 'react';
// import { CartTicketUsageBoard } from './CartTicketUsageBoard';
import { OnlineTicketUsageBoard } from '@kinderlabs-pos/feature/pos/online-tickets';
import {
	AppTicketUsageBoard,
	V2VaunceQrScanBoard,
} from '@kinderlabs-pos/feature/pos/vaunce-integration';
import { usePosRouter } from '../../../pages/routes';
import { MenuTabs } from './MenuTab';
import { PosBoardInMainPage } from './PosBoardInPos/PosBoardInMainPage';
import { SessionBoard } from './SessionBoard';

export interface IProductBoardProps {}
export const ProductBoard: React.FC<IProductBoardProps> = ({}) => {
	const [selectedTab, selectTab] = useState<0 | 1 | 2 | 3 | 4>(0);
	const { navigate결제 } = usePosRouter();
	const handleClick결제 = () => {
		navigate결제({
			mode: 'order',
		});
	};

	return (
		<Stack
			height={'100%'}
			overflow={'auto'}>
			<MenuTabs
				selectedTab={selectedTab}
				selectTab={selectTab}
			/>
			<Paper
				sx={(theme) => ({
					flex: 1,
					overflow: 'auto',
					backgroundColor: 'white',
					p: 1,
					border: `2px solid ${theme.palette.primary.main}`,
					borderTopWidth: 0,
					borderTopLeftRadius: 0,
					borderTopRightRadius: 0,
					borderBottomLeftRadius: theme.spacing(1.5),
					borderBottomRightRadius: theme.spacing(1.5),
				})}>
				<Suspense
					fallback={
						<Stack
							width={'100%'}
							height={'100%'}
							alignItems={'center'}
							justifyContent={'center'}>
							<CircularProgress />
						</Stack>
					}>
					<Box sx={{ height: '100%', overflow: 'auto' }}>
						{selectedTab === 0 && <PosBoardInMainPage />}
						{/* {selectedTab === 1 && <CartTicketUsageBoard />} */}
						{selectedTab === 1 && <AppTicketUsageBoard />}
						{selectedTab === 2 && <OnlineTicketUsageBoard />}
						{selectedTab === 3 && <SessionBoard />}
						{selectedTab === 4 && <V2VaunceQrScanBoard handleClick결제={handleClick결제} />}
					</Box>
				</Suspense>
			</Paper>
		</Stack>
	);
};
